<template>
    <b-modal v-model="modalAberto" scrollable centered title="Editar Usuário" header-bg-variant="secondary"
      header-text-variant="light" size="lg" @hide="closeModal">
      <b-overlay :show="carregandoModalEditar">
        <div class="container">
          <b-card :header="`Usuário: ${novoNome}`" header-class="text-center font-weight-bold">
            <b-form @submit="atualizarDados">
              <b-container fluid>
                <b-row>
                  <b-col cols="12" lg="6">
                    <b-form-group label="Nome">
                      <b-form-input v-model="novoNome"></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" lg="6">
                  <b-form-group label="CPF">
                    <b-form-input
                      :value="cpfFormatted"
                      @input="onCpfInput"
                      @keydown="onCpfKeydown"
                      v-bind="cpfMaskedInputProps"
                    />
                  </b-form-group>
                  </b-col>
                  <b-col cols="12" lg="6">
                    <b-form-group label="Email">
                      <b-form-input v-model="novoEmail"></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" lg="6">
                  <b-form-group label="Telefone">
                    <b-form-input
                      :value="telefoneFormatted"
                      @input="onTelefoneInput"
                      @keydown="onTelefoneKeydown"
                      v-bind="telefoneMaskedInputProps"
                    />
                  </b-form-group>
                  </b-col>

                  <b-col cols="12" lg="6">
                    <b-form-group label="OAB">
                      <b-form-input v-model="novoOAB"></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" lg="6">
                    <b-form-group label="Comunicação por Telefone/E-mail">
                      <b-form-checkbox v-model="novaComunicacao">Sim</b-form-checkbox>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="12">
                    <h5 class="mt-3 mb-1">Endereço</h5>
                  </b-col>
                  <b-col cols="12" lg="6">
                    <b-form-group label="Estado">
                      <b-form-select id="estados" :options="listaEstados" v-model="novoEstado" @change="estadoSelecionado"/>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12" lg="6">
                    <b-form-group label="Município">
                      <b-form-select id="municipio" :options="listaMunicipios" v-model="novoMunicipio.ID_MUNICIPIO"
                        :disabled="novoEstado === ''"/>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" lg="6">
                    <b-form-group label="Logradouro">
                      <b-form-input v-model="novoLogradouro"></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" lg="6">
                    <b-form-group label="Número">
                      <b-form-input v-model="novoNumero"></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" lg="6">
                    <b-form-group label="Complemento">
                      <b-form-input v-model="novoComplemento"></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" lg="6">
                    <b-form-group label="Bairro">
                      <b-form-input v-model="novoBairro"></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" lg="6">
                  <b-form-group label="CEP">
                    <b-form-input
                      :value="cepFormatted"
                      @input="onCepInput"
                      @keydown="onCepKeydown"
                      v-bind="cepMaskedInputProps"
                    />
                  </b-form-group>
                  </b-col>
                </b-row>
              </b-container>
            </b-form>
          </b-card>
        </div>
      </b-overlay>
      <template #modal-footer>
        <b-button size="sm" variant="success" @click="atualizarDados(String(itemSelecionado.ID_NOVO_USUARIO))">Salvar</b-button>
      </template>
    </b-modal>
</template>

<script lang="ts">
import { UtilsTS } from "@/utilsts";
import { mixins } from "vue-class-component";
import { Component, Vue, Prop } from "vue-property-decorator";
import usuarioService from "@/services/administracao/usuarioService";
import { SelectValue } from "@/types/select-value";
import { NovoUsuario } from "@/types/administracao/usuarios/novo-usuario";
import municipioService from "@/services/administracao/municipioService";
import { store } from "@/store";
import { UF } from "@/types/administracao/uf";
import { Municipio } from "@/types/administracao/municipio";

interface municipioR {
    ID_MUNICIPIO: number;
    NM_NOME: string;
}

@Component({
    components: {},
})
export default class ModalEditarUsuario extends mixins(UtilsTS, Vue) {
    @Prop({ required: true }) itemSelecionado!: NovoUsuario;
    
    modalAberto = true;

    listaEstados: SelectValue[] = [];
    listaMunicipios: SelectValue[] = [];
    carregandoModalEditar = false;
    novoNome = "";
    cpfDigits = "";
    telefoneDigits = "";
    cepDigits = "";
    novoCPF = "";
    novoEmail = "";
    novoTelefone = "";
    novoOAB = "";
    novoLogradouro = "";
    novoNumero = "";
    novoCEP = "";
    novoComplemento = "";
    novoBairro = "";
    novoMunicipio: municipioR = {
        ID_MUNICIPIO: 0,
        NM_NOME: "",
    };
    novoEstado = "";

    novaComunicacao = false;

  get cpfFormatted(): string {
    return this.formatCpfMask(this.cpfDigits);
  }

  get telefoneFormatted(): string {
    return this.formatTelefoneMask(this.telefoneDigits);
  }

  get cepFormatted(): string {
    return this.formatCepMask(this.cepDigits);
  }

  onCpfInput(value: string): void {
    const digits = this.digitsOnly(value, 11);
    this.cpfDigits = digits;
    this.novoCPF = digits;
  }

  onTelefoneInput(value: string): void {
    const digits = this.digitsOnly(value, 11);
    this.telefoneDigits = digits;
    this.novoTelefone = digits;
  }

  onCepInput(value: string): void {
    const digits = this.digitsOnly(value, 8);
    this.cepDigits = digits;
    this.novoCEP = digits;
  }

  onCpfKeydown(e: KeyboardEvent): void {
    const allowed = ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Home", "End", "Tab"];
    if (e.ctrlKey || e.metaKey) return;
    if (allowed.includes(e.key)) return;
    if (!/^\d$/.test(e.key)) e.preventDefault();
  }

  onTelefoneKeydown(e: KeyboardEvent): void {
    const allowed = ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Home", "End", "Tab"];
    if (e.ctrlKey || e.metaKey) return;
    if (allowed.includes(e.key)) return;
    if (!/^\d$/.test(e.key)) e.preventDefault();
  }

  onCepKeydown(e: KeyboardEvent): void {
    const allowed = ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Home", "End", "Tab"];
    if (e.ctrlKey || e.metaKey) return;
    if (allowed.includes(e.key)) return;
    if (!/^\d$/.test(e.key)) e.preventDefault();
  }

    async mounted(){
        this.atualizarCampos();
        this.carregarEstados();
    }

    async atualizarDados(id: string) {
        const cpfEnvio = this.cpfDigits;
        const telefoneEnvio = this.telefoneDigits;
        const cepEnvio = this.cepDigits;
        const data = {
            NOME: this.novoNome,
            CPF: cpfEnvio,
            EMAIL: this.novoEmail,
            TELEFONE: telefoneEnvio,
            OAB: this.novoOAB,
            LOGRADOURO: this.novoLogradouro,
            NUMERO: this.novoNumero,
            CEP: cepEnvio,
            COMPLEMENTO: this.novoComplemento,
            BAIRRO: this.novoBairro,
            ID_MUNICIPIO: this.novoMunicipio.ID_MUNICIPIO,
            FL_COMUNICA_TELEFONE: this.novaComunicacao,
        };
        try {
            this.carregandoModalEditar = true;
            const response = await usuarioService.atualizarNovoUsuario(String(id), data);
            if(response.status === 200 || response.status === 201) {
              this.$toast.success("Usuário editado com sucesso!");
              this.closeModal()
              this.$emit("reload")
            }
        } catch (e: any) {
            this.tratarError(e);
            this.$toast.error("Não foi possível editar o usuário.");
            this.closeModal()
        } finally {
            this.carregandoModalEditar = false;
        }
    }

    async carregarEstados() {
        try {
            store.blockScreen = true;
            const response = await municipioService.getUFs();
            this.listaEstados = response.map((estado: UF) => ({
                value: estado.ID_UF,
                text: estado.NM_NOME,
            }));
            this.listaEstados.unshift({ value: "", text: "Selecionar" });
            this.listaMunicipios.unshift({
                value: String(this.novoMunicipio.ID_MUNICIPIO),
                text: this.novoMunicipio.NM_NOME,
            });
        } catch (e: any) {
            this.tratarError(e);
        } finally {
            store.blockScreen = false;
        }
    }

    cancelaredicao() {
        this.novoEstado = "";
        this.novoNome = "";
        this.cpfDigits = "";
        this.novoEmail = "";
        this.telefoneDigits = "";
        this.novoOAB = "";
        this.novoLogradouro = "";
        this.novoNumero = "";
        this.cepDigits = "";
        this.novoComplemento = "";
        this.novoBairro = "";
        this.novoMunicipio = {
            ID_MUNICIPIO: 0,
            NM_NOME: "",
        };
    }

    async estadoSelecionado() {
        try {
            this.listaMunicipios = [];
            this.carregandoModalEditar = true;
            const response = await municipioService.getMunicipios(
                Number(this.novoEstado)
            );
            this.listaMunicipios = response.map((m: Municipio) => ({
                value: String(m.ID_MUNICIPIO),
                text: m.NM_NOME,
            }));
        } catch (e: any) {
            this.tratarError(e);
        } finally {
            this.carregandoModalEditar = false;
        }
    }

    atualizarCampos() {
        this.novoNome = this.itemSelecionado.NOME;
        this.novoEmail = this.itemSelecionado.EMAIL;
        this.novoOAB = this.itemSelecionado.OAB;
        this.novoLogradouro = this.itemSelecionado.LOGRADOURO;
        this.novoNumero = this.itemSelecionado.NUMERO;
        this.novoComplemento = this.itemSelecionado.COMPLEMENTO;
        this.novoBairro = this.itemSelecionado.BAIRRO;
        this.cpfDigits = this.digitsOnly(this.novoCPF, 11);
        this.telefoneDigits = this.digitsOnly(this.novoTelefone, 11);
        this.cepDigits = this.digitsOnly(this.novoCEP, 8);
        if (this.itemSelecionado.CRP_MUNICIPIO) {
            this.novoMunicipio = {
                ID_MUNICIPIO: this.itemSelecionado.CRP_MUNICIPIO.ID_MUNICIPIO,
                NM_NOME: this.itemSelecionado.CRP_MUNICIPIO.NM_NOME,
            };
        }
        this.novaComunicacao = this.itemSelecionado.FL_COMUNICA_TELEFONE;
    }

    closeModal() {
        this.cancelaredicao();
        this.$emit("close");
    }

}
</script>
